import { Buffer } from "buffer";
import axios from "axios";
import { readStoredAuthToken } from "../auth/authApi";
import { BACKEND_URL } from "../config";
import { fetchImage } from "./itemsServices";
import { loadCategoryItems, queryCsvItems } from "./csvCardCatalog";
import { getCardsLogoUrl, isCardsLogoRaster } from "./cardsLogoMap";

export const likeItem = async (id_item, categorie) => {
  const t = readStoredAuthToken();
  let url = `${BACKEND_URL}/items/${id_item}`;

  if (categorie === "Tools") {
    url += "/64761102ba22fed734b9de7a";
  } else if (categorie === "Resos") {
    url += "/64761222ba22fed734b9de7d";
  } else {
    url += "/64761240ba22fed734b9de81";
  }

  const res = await axios.post(
    url,
    {},
    {
      headers: t ? { Authorization: `Bearer ${t}` } : {},
    }
  );

  return res;
};

export const getUxers = async () => {
  const res = await axios.get(`${BACKEND_URL}/uxers/filter`, {
    params: {
      limit: 1000,
    },
  });

  return res.data;
};

export const getNumberItems = async () => {
  const [t, r, i] = await Promise.all([
    loadCategoryItems("TOOLS"),
    loadCategoryItems("RESOS"),
    loadCategoryItems("IDEAZ"),
  ]);
  return {
    Tools: t.length,
    Resos: r.length,
    Ideaz: i.length,
  };
};

export const getItems = async ({
  category = "Tools",
  tags = "",
  search = "",
  platform = [],
  price = [],
  page = 1,
}) => {
  if (!["Tools", "Resos", "Ideaz"].includes(category)) {
    return { noData: true };
  }
  if (tags === "Favs") {
    const t = readStoredAuthToken();
    const res = await axios.get(`${BACKEND_URL}/profile/my-favs`, {
      headers: t ? { Authorization: `Bearer ${t}` } : {},
    });

    if (category === "Tools") {
      return {
        totalItems: res.data.myTools.length,
        items: res.data.myTools,
        page: page,
      };
    }

    if (category === "Resos") {
      return {
        totalItems: res.data.myResos.length,
        items: res.data.myResos,
        page: page,
      };
    }

    if (category === "Ideaz") {
      return {
        totalItems: res.data.myIdeaz.length,
        items: res.data.myIdeaz,
        page: page,
      };
    }
  } else {
    return queryCsvItems({
      category: category.toUpperCase(),
      tag: tags,
      search,
      platform,
      price,
      page,
      limit: 60,
    });
  }
};

export const getItemImage = async (item_id) => {
  const res = await axios.get(`${BACKEND_URL}/items/images/${item_id}`, {
    responseType: "arraybuffer",
    responseEncoding: "base64",
  });
  const buffer = Buffer.from(res.data, "base64");
  let binary = "";
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
};

export const getNumberOfItems = async (category) => {
  if (!["Tools", "Resos", "Ideaz"].includes(category)) {
    return { noData: true };
  }

  const items = await loadCategoryItems(category.toUpperCase());
  return items.length;
};

export const clickItem = async (item_id) => {
  const t = readStoredAuthToken();
  return await axios.post(
    `${BACKEND_URL}/items/click-item/${item_id}`,
    {},
    {
      headers: t ? { Authorization: `Bearer ${t}` } : {},
    }
  );
};

function svgTextToBase64(svg) {
  const buffer = Buffer.from(svg, "utf-8");
  let binary = "";
  const bytes = new Uint8Array(buffer);
  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}

function loadCsvCardLogo(img) {
  if (isCardsLogoRaster(img)) {
    return Promise.resolve(null);
  }
  const localUrl = getCardsLogoUrl(img);
  const fetchText = (url) =>
    fetch(url).then((r) =>
      r.ok ? r.text() : Promise.reject(new Error("icon fetch failed"))
    );
  const remote = () => {
    const base =
      process.env.REACT_APP_ITEM_ICONS_BASE || `${BACKEND_URL}/images/items`;
    return fetchText(`${base}/${encodeURIComponent(img)}`);
  };
  const first = localUrl ? fetchText(localUrl) : Promise.reject(new Error("no local"));
  return first
    .catch(() => remote())
    .then((text) => svgTextToBase64(text))
    .catch((err) => {
      console.error("Error loading CSV item image:", err);
      return null;
    });
}

export const loadImage = (item) => {
  if (!item) return Promise.resolve(null);
  if (item._source === "csv") {
    if (!item.img) return Promise.resolve(null);
    return loadCsvCardLogo(item.img);
  }
  if (!item._id) return Promise.resolve(null);
  return fetchImage("items", item._id)
    .then((img) => img || null)
    .catch((err) => {
      console.error("Error fetching image:", err);
      return null;
    });
};
